import * as React from "react"

import Container from "./Container"

const Grid = ({
	className,
	containerClassName,
	innerContainerClassName,
	children,
	columns = 12,
	withContainer = true,
}) => {
	const grid = (
		<div className={`grid grid-cols-${columns} gap-x-20 md:gap-x-40 ${className || ""}`}>
			{children}
		</div>
	)
	return withContainer ? (
		<Container className={containerClassName} innerClassName={innerContainerClassName}>
			{grid}
		</Container>
	) : (
		grid
	)
}

export default Grid
